import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { MONTHLY } from 'self-service-api/constants/Terms';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { currentSkuIdForProductSelector } from '../../selectors/ProductsSelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
const Bold = styled.span.withConfig({
  displayName: "ComparePriceDisplay__Bold",
  componentId: "ebu1wl-0"
})(["font-weight:600;"]);
const ComparePriceDisplay = ({
  apiName
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const skuId = useSelector(state => {
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const pricingInfo = useSelector(state => {
    return calculatedPriceSelector(state, {
      productConfigurations: [createProductConfig({
        skuId
      })],
      queryParamTerm: MONTHLY
    });
  });
  const price = pricingInfo && pricingInfo.monthly && pricingInfo.monthly.calculatedPrice;
  const seleniumId = apiName || 'loading';
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "compare.pricing.startsAt_jsx",
    elements: {
      PriceDisplay,
      Bold
    },
    options: {
      currencyCode,
      seleniumId,
      price
    }
  });
};
export default ComparePriceDisplay;